import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { isNewEventTypeSelector, isOpenSelector } from '../selectors'
import { closeModal, closeModalWithStoreIntact, fetchEventTypeData, submitModal } from '../slice'
import { EditPermissionsModal as EditPermissionsModalNew } from './new_modal'

export const EditPermissionsModal = ({ onSuccess, scopeType, profileScopeType, profilePage }) => {
  const dispatch = useDispatch()
  const isOpen = useSelector(isOpenSelector)
  const isNew = useSelector(isNewEventTypeSelector)

  const handleSubmit = () => {
    dispatch(submitModal({ onSuccess, profileScopeType, profilePage }))
  }

  const onClose = () => {
    if (isNew) {
      dispatch(closeModalWithStoreIntact())
    } else {
      dispatch(closeModal())
    }
  }

  useEffect(() => {
    if (!isOpen) return undefined

    dispatch(fetchEventTypeData())

    return () => dispatch(closeModal())
  }, [dispatch, isOpen])

  return (
    <EditPermissionsModalNew isOpen={isOpen} onSubmit={handleSubmit} onClose={onClose} scopeType={scopeType} />
  )
}
